
/**
 * @file dcp-client/worker/supervisor2/evaluator-manager.js
 *
 * A support class for Supervisor2.
 * It is for managing when the evaluator goes down and comes back.
 * Also helps with evaluator creation throttling.
 * The screensaver worker, sandbox OOMs and evaluator throttling are the main scenarios.
 *
 * @author Paul, paul@distributive.network
 * @date Feb-April 2023,
 *       May 2024
 * @module evaluator-manager
 * @copyright Copyright (c) 2018-2025, Distributive Corp. All Rights Reserved
 */
// @ts-check
'use strict';

/**
 * Evaluator down management.
 **/
class EvaluatorManager
{
  constructor()
  {
    /**
     * The evaluatorHandle 'end' event has fired for all sandboxes and
     * a new sandbox cannot be created.
     * @type { boolean }
     */
    this.reallyDown = false;
    /**
     * Used to mitigate terminated handler being called too many times.
     * @type {boolean}
     */
    this.downInterlock = false;
    /**
     * The # of spinning createSandbox instances.
     * @type {number}
     */
    this.createSandboxRefCount = 0;
  }
  /**
   * Unable to complete sandbox.start().
   * May be due to evaluator (or screensaver) being down or new evaluator sandbox creation is rate limited.
   * @type {boolean}
   */
  get waitingToCreateSandbox ()
  {
    // Returns true when spinCreateSandbox is spinning.
    return this.createSandboxRefCount > 0;
  }
  /**
   * Reset all properties to their default state.
   */
  initialize ()
  {
    this.reallyDown = false;
    this.downInterlock = false;
    this.createSandboxRefCount = 0;
  }
}
exports.EvaluatorManager = EvaluatorManager;
